import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sequence-editor-format-clean",
  "use": "icon-sequence-editor-format-clean-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17 16\" fill=\"none\" id=\"icon-sequence-editor-format-clean\">\n    <path d=\"M6.5026 4.0026H9.83594M9.83594 4.0026H13.1693M9.83594 4.0026L8.5026 8.0026M7.16927 12.0026L7.61394 10.6693M3.83594 3.33594L13.1693 12.6693\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol